module.exports = __webpack_public_path__ + "img/finance.93b50433.svg";